import { Meta } from '@/src/components/common/Meta';
import { JamTaskInfo } from '@/src/components/game/JamChallengeDetails/JamTask/JamTaskInfo';
import { useJamChallengeDetails } from '@/src/store/jam-challenge-details.context';
import { useJamEventDetails } from '@/src/store/jam-event-details.context';
import { i18nKeys } from '@/src/utils/i18n.utils';
import { useTranslation } from 'react-i18next';

export const JamTaskInfoPage: React.FC = () => {
  const { t } = useTranslation();
  const { event } = useJamEventDetails();
  const { task, selectedJamChallenge } = useJamChallengeDetails();

  const taskTitle = `${t(i18nKeys.myJams.challenges.details.task.title)} ${task?.taskNumber}`;
  const challengeTitle = selectedJamChallenge?.title ?? t(i18nKeys.meta.challenge.title);
  const eventTitle = event?.title ?? t(i18nKeys.meta.event.title);
  const pageTitle = `${taskTitle} | ${challengeTitle} | ${eventTitle}`;

  return (
    <>
      <Meta title={pageTitle} />
      <JamTaskInfo />
    </>
  );
};
